import { DEFAULT_ADM_S2S_CONFIG } from '@pubstack/common/src/prebidConfig'
import { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { useKleanadsScopeConfigFind, useUpdateKleanadsS2SConfig } from '~/api/admin/kleanads-config.api'
import Button from '~/components/Button'
import { IllustrationMessage } from '~/components/IllustrationMessage'
import { Link } from '~/components/Link'
import { RouterUnstyledLink } from '~/components/RouterUnstyledLink'

const JSON_SPACE_COUNT = 2

export const AdminScopeAdmPrebidServerConfig: FunctionComponent = () => {
  const { scopeId } = useParams()

  const { data: scopeConfig, isLoading, isFetching } = useKleanadsScopeConfigFind(scopeId ?? '')
  const { mutateAsync: updateS2SConfig } = useUpdateKleanadsS2SConfig(scopeId ?? '', {
    successToast: 'The s2s config has been created.',
    errorToast: 'An error has occurred, please retry later.',
  })

  const createS2SConfigData = async () => {
    await updateS2SConfig(DEFAULT_ADM_S2S_CONFIG)
  }

  const s2sConfig = scopeConfig?.pbjsConfig?.s2sConfig
  const isScopeConfigCreated = !!scopeConfig
  const paramsJsonValue = JSON.stringify(s2sConfig, undefined, JSON_SPACE_COUNT)

  const newS2SConfigButton = (
    <Button variant={'primary'} onClick={createS2SConfigData} trackingLabel={'adm-admin-s2s-config-new'}>
      New default s2s Config
    </Button>
  )

  if (isLoading || isFetching) {
    return null
  }

  return s2sConfig ? (
    <div className={'flex flex-col gap-5 pb-5'}>
      <h2>S2S config</h2>
      <p className={'text-sm/[22px] text-slate-grey'}>Bidders and aliases are built per stack from its bidder rule; they are not stored here.</p>
      <textarea
        className={
          'min-h-[200px] w-full resize-none rounded border border-platinum bg-ghost p-2 font-inconsolata text-sm/[22px] whitespace-pre text-jet outline-none focus:border-silver active:border-silver'
        }
        spellCheck={false}
        value={paramsJsonValue}
        rows={25}
        disabled={true}
      />
    </div>
  ) : !isScopeConfigCreated ? (
    <IllustrationMessage iconName={'night_sky'} iconSize={'190px'} title={'There is no Ad management scope configuration.'}>
      <RouterUnstyledLink to={'../adm-settings'}>
        <Link label={'Create one in Ad Management settings'} trackingLabel={'adm-s2s-to-adm-settings-navigate'}></Link>
      </RouterUnstyledLink>
    </IllustrationMessage>
  ) : (
    <IllustrationMessage iconName={'night_sky'} iconSize={'190px'} title={'There is no s2s configuration.'}>
      {newS2SConfigButton}
    </IllustrationMessage>
  )
}
